
export namespace UIService {

    export const isEmbedded = () => {
        const field = 'embeded';
        const url = window.location.href;
        if (url.indexOf('?' + field + '=') >= 0)
            return true;
        else if (url.indexOf('&' + field + '=') >= 0)
            return true;
        return false;
    };

    export const getLoginParam = (name: string = "p", url: string = window.location.href) => {
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };


    export const isInView = (ref: React.RefObject<HTMLDivElement>) => {
        if (!ref || !ref.current) return false;

        const bounding = ref.current.getBoundingClientRect();

        const isInView =
            bounding.bottom - bounding.height + 20 <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth);

        return isInView;
    };

    export const removeHeader = () => {
        try {
            const bodies = document.getElementsByTagName("body");
            if (bodies && bodies.length) {
                bodies[0].classList.add("no-header");
            }
        }
        catch { }
    };

    export const handleKeepViewMode = (
        main: React.RefObject<HTMLDivElement>,
        wrapper: React.RefObject<HTMLDivElement>,
        content: React.RefObject<HTMLDivElement>,
        title?: React.RefObject<HTMLHeadingElement>
    ) => {

        if (!main || !main.current) return;
        if (!wrapper || !wrapper.current) return;
        if (!content || !content.current) return;

        const mainElement = main.current;
        const wrapperElement = wrapper.current;

        let calculate = null;
        let calculatePadding = null;
        const isPortrait = window.innerHeight >= window.innerWidth;

        if (mainElement.offsetWidth <= 576 && isPortrait) {

            calculate = mainElement.offsetWidth * 9 / 16;
            calculatePadding = mainElement.offsetWidth * 9 / 16;

            if (calculate) {
                mainElement.style.paddingTop = calculatePadding + 'px';
                wrapperElement.style.height = calculate + 'px';
                wrapperElement.style.minHeight = calculate + 'px';
            }

            if (!title || !title.current) return;
            const titleElement = title.current;

            if ((52 - window.scrollY) > 0) {
                titleElement.style.height = (52 - window.scrollY) + 'px';
                titleElement.style.opacity = "" + (1 - window.scrollY / 52);
            } else {
                titleElement.style.height = "0";
                titleElement.style.minHeight = "0";
            }

        } else {
            mainElement.style.paddingTop = '0px';
            wrapperElement.style.height = 'auto';
            wrapperElement.style.minHeight = 'auto';
        }
    };

    export const handleKeepTvEqualHeight = (
        tv: React.RefObject<HTMLDivElement>,
        conductorWrapper: React.RefObject<HTMLDivElement>,
        conductorList: React.RefObject<HTMLDivElement>,
    ) => {

        if (!tv || !tv.current) return;
        if (!conductorWrapper || !conductorWrapper.current) return;
        if (!conductorList || !conductorList.current) return;

        const tvElement = tv.current;
        const wrapperElement = conductorWrapper.current;
        const listElement = conductorList.current;

        if (!tvElement || !listElement) return;
        let offsetHeight = tvElement.offsetHeight;

        if (wrapperElement && document.body.offsetWidth >= 992) {
            if (offsetHeight) {
                wrapperElement.style.minHeight = offsetHeight + 'px';
                wrapperElement.style.height = offsetHeight + 'px';
                listElement.style.height = offsetHeight - listElement.offsetTop + 'px';
            }
        }
    };
}